import { Component, computed, inject } from '@angular/core';
import { SidebarService } from '@core/components/sidebar/service/sidebar.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { SidebarContentComponent } from '@core/components/sidebar/sidebar-content.component';

@Component({
  selector: `app-sidebar`,
  imports: [SidebarContentComponent],
  template: `
    <div class="flex h-full w-full">
      <div
        class="h-full transition-[width] duration-200 ease-in-out"
        [style.width.px]="width()">
        <app-sidebar-content />
      </div>
      <!--
        data-resize-boundary: everything routed in here lives next to the main
        menu, so resizable sidebars must not grow past this element. Read by
        ResizeService.
      -->
      <div
        class="base--bg h-full flex-1 overflow-x-hidden"
        data-resize-boundary>
        <ng-content></ng-content>
      </div>
    </div>
  `,
})
export class SidebarComponent {
  /** INJECTIONS **/
  /****/
  private readonly sidebarService = inject(SidebarService);

  /** PROPERTIES **/
  /****/
  public static SIDEBAR_COLLAPSED_WIDTH = 67;

  /****/
  public static SIDEBAR_EXPANDED_WIDTH = 300;

  /****/
  protected readonly width = computed(() => {
    if (this.collapsed()) return SidebarComponent.SIDEBAR_COLLAPSED_WIDTH;
    else return SidebarComponent.SIDEBAR_EXPANDED_WIDTH;
  });

  /****/
  private readonly collapsed = toSignal(this.sidebarService.sidebarCollapsed$);
}
